/**
 * 工具函数
 */

export function paddingString(str: string, len: number = 2, pad: string = '0'): string {
  if (str.length < len) {
    return new Array(len - str.length).fill(pad).join('') + str;
  }
  return str;
}

export function formatDate(ts: number | Date) {
  let date: Date;
  if (typeof ts === 'number') {
    date = new Date(ts);
  } else {
    date = ts;
  }
  let month = paddingString(`${date.getMonth() + 1}`);
  let day = paddingString(`${date.getDate()}`);
  const hour = paddingString(`${date.getHours()}`);
  const minute = paddingString(`${date.getMinutes()}`);
  return `${date.getFullYear()}${month}${day} ${hour}:${minute}`;
}

export function formatDate2(ts: number | Date) {
  let date: Date;
  if (typeof ts === 'number') {
    date = new Date(ts);
  } else {
    date = ts;
  }
  let month = paddingString(`${date.getMonth() + 1}`);
  let day = paddingString(`${date.getDate()}`);
  const hour = paddingString(`${date.getHours()}`);
  const minute = paddingString(`${date.getMinutes()}`);
  const second = paddingString(`${date.getSeconds()}`);
  return `${date.getFullYear()}-${month}-${day} ${hour}:${minute}:${second}`;
}

// 当前支持的语音设备
export const PlatformMap = {
  baidu: 'baidu',
  xiaoAi: 'xiaoAi',
  tmall: 'tmall',
};
export const PlatformNameMap = {
  [PlatformMap.baidu]: '小度',
  [PlatformMap.xiaoAi]: '小爱',
  [PlatformMap.tmall]: '天猫精灵',
};

export * from './statistic';
export * from './env';
export * from './bridge';
export * from './navUtil';
